import { SaleFactorType } from "src/app/enum/sale-factor-type";
import { UIdModel } from "./uid-model";

export class SelectDrug {
  public constructor() {
    this.stockId = '';
    this.stockItemId = '';
    this.drugId = '';
    this.count = 1;
    this.sellPrice = 0;
    this.packageCount = 1;
    this.drugPackageCount = 1;
    this.buyPrice = 0;
    this.inventory = 1;
    this.discount = 0;
    this.discountPercent = 0;
    this.insurancePrice = 0;
    this.shareCurrencyPrice = 0;
    this.elementPrice = 0;
    this.paidPrice = 0;
  }
  public stockId: string;
  public stockName?: string;
  public genericCode?: number;
  public genericName?: string;
  public brandName?: string;
  public discountPercent: number;
  public erx?: number;
  public persianName?: string;
  public name?: string;
  public countryName?: string;
  public drugPackageCount: number;
  public packageCount: number;
  public expireDate?: Date;
  public companyName?: string;
  public buyPrice: number;
  public inventory: number;


  public id?: string;

 public count: number;
  public drugId: string;
  public discount: number;
  public sellPrice: number;
  public paidPrice: number;
  public stockItemId: string;
  public elementPrice: number;
  public insurancePrice: number;
  public shareCurrencyPrice: number;
}

export class BackendSellModel {
  public constructor() {
    this.totalPrice = 0;
    this.DrugList = [];
    this.saleFactorType = '3';
    this.technicalRight = 0;
    this.insuranceTechnicalRight = 0;
    this.noninsurancePrice = 0;
    this.paidPrice = 0;
    this.drugTariffPrice = 0;
    this.totalPresc = 0;
    this.insurancePrice = 0;
  }
  // PatientPhone!: number;
  public patientNationalCode?: string;
  public insuranceId?: string;
  public patientFullname?: string;
  public patientMobileNumber?: string;
  public docktorFullName?: string;
  public employeeNumber?: string;
  public doctorCode?: number;
  public trackingCode?: string;
  public prescriptionDate: any;

  public saleFactorType: string;

  public requestPrscId?: any;
  public headePrscId?: number;
  public docId?: string;

  public insuranceTechnicalRight: number;
  public noninsurancePrice: number;
  public insurancePrice: number;
  public paidPrice: number;
  public drugTariffPrice: number;

  public ValidateInsurance: any;
  public DrugList: BackendSellDrugItemModel[];

  public totalPrice: number;
  public technicalRight: number;
  public totalPresc: number;
}

export class BackendSellDrugItemModel {
  public constructor(
    stockItemId: string,
    drugId: string,
    drugName: string,
    sellPrice: number,
    count: number,
    discount: number,
    totalPrice: number,
    insurancePrice: number,
    shareCurrencyPrice: number,
    paidPrice: number
      ) {
    this.stockItemId= stockItemId;
    this.drugId= drugId;
    this.drugName= drugName;
    this.sellPrice= sellPrice;
    this.count= count;
    this.discount= discount;
    this.totalPrice= totalPrice;
    this.insurancePrice= insurancePrice;
    this.shareCurrencyPrice= shareCurrencyPrice;
    this.paidPrice= paidPrice;
  }

  public stockItemId: string;
  public drugId: string;
  public drugName: string;
  public sellPrice: number;
  public count: number;
  public discount: number;
  public totalPrice: number;
  public insurancePrice: number;
  public shareCurrencyPrice: number;
  public paidPrice: number;
}

export class SelectDrugValidation {
  public constructor() {}

  public drugNameMessage?: string;
  public countMessage?: string;
  public discountMessage?: string;
}

export class SaleImport {
  constructor(documentType: string) {
    this.drugList = [];
    this.paidPrice = 0;
    this.documentType = documentType;
    this.elementPrice = 0;
    this.insurancePrice = 0;
    this.saleFactorType = SaleFactorType.OTC;
    this.totalInsurance = 0;
    this.technicalRight = 0;
    this.prescriptionPrice = 0;
    this.shareCurrencyPrice = 0;
    this.insuranceTechnicalRight = 0;
    this.insurance="OTC";
  }

  public docId?: string;
  public paidPrice: number;
  public trackingCode?: string;
  public insurance: string;
  public insuranceId?: string;
  public headePrscId?: string;
  public documentType: string;
  public elementPrice: number;
  public insurancePrice: number;
  public requestPrscId?: string;
  
  public patientFirstName?: string;
  public patientLastName?: string;
  public patientNationalCode?: string;
  public patientMobileNumber?: string;
  public birthDate?: string;
  public employeeNumber?: string;

  public doctorCode?: string;
  public doctorFirstName?: string;
  public doctorLastName?: string;

  public saleFactorType: SaleFactorType;
  public totalInsurance: number;
  public technicalRight: number;
  public drugList: SaleDrugItem[];
  public prescriptionDate?: string;
  public prescriptionPrice: number;
  public shareCurrencyPrice: number;
  public insuranceTechnicalRight: number;
  public serialInsurance?: string;
  public insuranceBookPage?: string;
}

export class SaleDrugItem {
  constructor(
    count: number,
    drugId: string,
    discount: number,
    paidPrice: number,
    sellPrice: number,
    packageCount: number,
    inventoryDetailId: string,
    elementPrice: number,
    insurancePrice: number,
    shareCurrencyPrice: number
  ) {
    this.count = count;
    this.drugId = drugId;
    this.discount = discount;
    this.sellPrice = sellPrice;
    this.paidPrice = paidPrice;
    this.inventoryDetailId = inventoryDetailId;
    this.packageCount = packageCount;
    this.elementPrice = elementPrice;
    this.insurancePrice = insurancePrice;
    this.shareCurrencyPrice = shareCurrencyPrice;
  }

  public genericCode?: number;
  public brandName?: string;
  public erx?: number;
  public expireDate?: string;
  
  public count: number;
  public drugId: string;
  public discount: number;
  public sellPrice: number;
  public paidPrice: number;
  public packageCount: number;
  public inventoryDetailId: string;
  public elementPrice: number;
  public insurancePrice: number;
  public shareCurrencyPrice: number;
  public drugUIds: UIdModel[]=[];
}

export class TechnicalRight {
  constructor(
    id: string,
    name: string,
    isOTC: boolean,
    isHoliday: boolean,
    startTime: string,
    endTime: string,
    amount: number
  ) {
    this.id = id;
    this.name = name;
    this.isOTC = isOTC;
    this.isHoliday = isHoliday;
    this.startTime = startTime;
    this.endTime = endTime;
    this.amount = amount;
  }
  
  public id: string;
  public name: string;
  public isOTC: boolean;
  public isHoliday: boolean;
  public startTime: string;
  public endTime: string;
  public amount: number;
}

export class TechnicalRightViewModel {
  constructor(
    otc: TechnicalRight,
    free: TechnicalRight,
  ) {
    this.otc = otc;
    this.free = free;
  }
  
  public otc: TechnicalRight;
  public free: TechnicalRight;
}
